import React, { useState, useCallback } from "react";
import { QueryInput } from "./components/QueryInput";
import { ResultDisplay } from "./components/ResultDisplay";
import { generateVisualization } from "./services/geminiService";
import type { VisualizationResponse } from "./types";

// sutiable component name

const ArtifialIntelligence: React.FC = () => {
  const [query, setQuery] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [result, setResult] = useState<VisualizationResponse | null>(null);

  const handleSubmit = useCallback(async () => {
    if (!query.trim() || isLoading) return;

    setIsLoading(true);
    setError(null);
    setResult(null);

    try {
      const response = await generateVisualization(query);
      setResult(response);
    } catch (err) {
      console.error(err);
      setError(
        "Failed to generate visualization. Please check your query or API key and try again."
      );
    } finally {
      setIsLoading(false);
    }
  }, [query, isLoading]);

  const handleExampleQuery = (exampleQuery: string) => {
    setQuery(exampleQuery);
  };

  return (
    <div className="min-h-screen bg-gray-50 text-white-800 font-sans">
      <div className="container mx-auto px-4 py-8">
        <header className="text-center mb-8">
          <h1 className="text-4xl font-bold text-blue-600">AI Assistant</h1>
          {/* <p className="text-white-400 mt-2">
            Generate SQL queries and charts from natural language
          </p> */}
        </header>

        <main className="flex flex-col lg:flex-row gap-8">
          <div className="lg:w-1/3 flex flex-col gap-6">
            <QueryInput
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              onSubmit={handleSubmit}
              isLoading={isLoading}
            />
            <div className="bg-white-800/50 p-4 rounded-lg border border-white-700">
              <h3 className="font-semibold mb-3 text-white-300">
                Try an example:
              </h3>
              <div className="flex flex-col gap-2">
                <button
                  onClick={() =>
                    handleExampleQuery(
                      "Show district-wise Artilication pendency"
                    )
                  }
                  className="text-left text-sm text-blue-400 hover:text-blue-300 transition-colors duration-200"
                >
                  District-wise pendency
                </button>
                <button
                  onClick={() =>
                    handleExampleQuery(
                      "How many applications were received per month this year?"
                    )
                  }
                  className="text-left text-sm text-blue-400 hover:text-blue-300 transition-colors duration-200"
                >
                  Monthly application volume
                </button>
                <button
                  onClick={() =>
                    handleExampleQuery(
                      "Which taluk has the highest pending applications?"
                    )
                  }
                  className="text-left text-sm text-blue-400 hover:text-blue-300 transition-colors duration-200"
                >
                  Top taluks by pending cases
                </button>
              </div>
            </div>
          </div>
          <div className="lg:w-2/3">
            <ResultDisplay
              isLoading={isLoading}
              error={error}
              result={result}
            />
          </div>
        </main>
        {/* <footer className="text-center mt-12 text-white-500 text-sm">
                    <p>Powered by Google Gemini. For demonstration purposes only.</p>
                </footer> */}
      </div>
    </div>
  );
};

export default ArtifialIntelligence;
